import { Form, Formik } from 'formik';
import { Button, Col } from 'reactstrap';
import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import { FormInputField, FormInputFieldType } from '../../common/components/formFields';
import { fetchAuctionNotes, saveAuctionNote } from '../VehicleActions';
import CommonErrorLabel from '../../common/components/CommonErrorLabel';

const MAX_NOTE_CHARACTERS = 1000;

function AddVehicleNoteForm({ searchParams }) {
  const [noteContentError, setNoteContentError] = useState(null);
  const { id: auctionId } = useParams();
  const dispatch = useDispatch();

  const handleSubmit = (values, { setSubmitting, setFieldValue }) => {
    setSubmitting(true);
    const error = validateNoteContent(values.content);
    if (error) {
      setNoteContentError(error);
      setSubmitting(false);
      return;
    }
    setNoteContentError(null);
    dispatch(
      saveAuctionNote(values, auctionId, () => {
        setFieldValue('content', '');
        dispatch(fetchAuctionNotes(searchParams, auctionId));
      }),
    );
    setSubmitting(false);
  };

  const validateNoteContent = (value) => {
    if (!value) return 'Field is required';
    if (value.length >= MAX_NOTE_CHARACTERS)
      return `Max length equals ${MAX_NOTE_CHARACTERS} characters`;
    return null;
  };

  return (
    <div className="mb-3">
      <Formik
        initialValues={{
          content: '',
        }}
        onSubmit={handleSubmit}
      >
        <Form noValidate>
          <div className="dealer-note-form">
            <Col className="note-editor">
              <div className="d-flex justify-content-between align-items-center px-2">
                <span>Add note</span>
                <Button type="submit" className="rounded-pill btn-light" size="sm">
                  Add
                </Button>
              </div>
              <div>
                <Col>
                  <FormInputField
                    noStyling={true}
                    style={{ height: `${125}px`, resize: 'none' }}
                    name="content"
                    type={FormInputFieldType.TEXTAREA}
                  />
                </Col>
              </div>
            </Col>
          </div>
          {noteContentError ? (
            <p>
              <CommonErrorLabel value={noteContentError} />
            </p>
          ) : null}
        </Form>
      </Formik>
    </div>
  );
}

export default AddVehicleNoteForm;
